import { bindable, ICustomElementViewModel } from 'aurelia';
import './db-filter.scss';
import { CdsDrawer } from '@chicksgroup/web-components';

export class DbFilter implements ICustomElementViewModel {
    blogsSearchEvt: boolean = false;
    postLoading: boolean = false;
    blogsResults: boolean = false;
    sortRef;
    subCategoriesRef;
    drawerRef: CdsDrawer;
    private _drawerScrollHandler: () => void;
    filtersActive = new Set();
    isDrawerOpen = false;
    @bindable loading;
    @bindable searchQuery: string = '';
    @bindable blogposts: any[] = [];
    @bindable sortItems: any[] = [];
    @bindable categories: any[] = [];
    @bindable sortBy: string = '';
    @bindable blogRoute: string = '';
    @bindable parent: any;
    collapseRef: any;

    async attached() {
        await this.drawerRef?.updateComplete;

        const shadowRoot = this.drawerRef?.shadowRoot;
        if (!shadowRoot) return;

        const style = document.createElement('style');
        style.textContent = `
            .drawer-header { position: sticky; top: 0; z-index: 999999; }
            .drawer-header.scrolled { box-shadow: 0 1px 0 0 var(--cds-drawer-divider-color, gray); }
        `;
        shadowRoot.appendChild(style);

        const drawerEl = shadowRoot.querySelector('.drawer');
        if (drawerEl) {
            const headerEl = shadowRoot.querySelector('.drawer-header');
            this._drawerScrollHandler = () => {
                headerEl?.classList.toggle('scrolled', (drawerEl as HTMLElement).scrollTop > 0);
            };
            drawerEl.addEventListener('scroll', this._drawerScrollHandler, { passive: true });
        }
    }

    detached() {
        const drawerEl = this.drawerRef?.shadowRoot?.querySelector('.drawer');
        if (drawerEl && this._drawerScrollHandler) {
            drawerEl.removeEventListener('scroll', this._drawerScrollHandler);
        }
    }

    async changeSelectHandler(event) {
        const value = event?.detail?.value;
        if (['popular', 'all'].includes(value)) {
            this.filtersActive.clear();
        } else {
            this.filtersActive.add('sort');
        }
        if (this.parent && typeof this.parent.changeSelectHandler === 'function') {
            await this.parent.changeSelectHandler(event);
        }
    }

    async handleDrawerToggle(event) {
        this.isDrawerOpen = event.detail.value;
        !this.collapseRef.open && this.collapseRef.collapseClick();
        if (!this.isDrawerOpen && this.searchQuery?.length || this.parent.searchQuery?.length) {
            setTimeout(async () => {
                this.searchQuery = '';
                this.parent.searchQuery = '';
                await this.parent.pageChanged();
            }, 500);
        }
    }

    async clearFilters() {
        await this.parent.clearFilters();
    }

    async functionTrigger(event) {
        const value = event?.detail?.value;
        if (['popular', 'all'].includes(value)) {
            this.filtersActive.clear();

        } else {
            this.filtersActive.add('category');
        }
        if (this.parent && typeof this.parent.changeSelectHandler === 'function') {
            this.parent.changeSelectHandler(event);
        }
    }

    async tagClickHandler(tag) {
        if (this.parent && typeof this.parent.tagClickHandler === 'function') {
            await this.parent.tagClickHandler(tag);
        }
    }
}
